import { Plan, Transaction } from "../models";

export const resolveTransactionPlanNames = (
  row: Transaction,
  plans: Plan[] | undefined,
  planId?: string
) => {
  return (
    row.charges?.reduce<string | undefined>((names, charge) => {
      if (planId && planId !== charge.planId) return names;
      const planName = charge.planId
        ? plans?.find((plan) => plan.id === charge.planId)?.name
        : undefined;
      if (planName) {
        if (!names) {
          return planName;
        }
        return names + ", " + planName;
      }
      return names;
    }, undefined) || "N/A"
  );
};
